export const REG_EXP_SCORES = /[a-zа-яё-]/gi
